import { acionaFuncionalidade as acionaRedeCredenciada } from '@/views/4/RegrasDeNegocio4'
import { acionaFuncionalidade as acionaBoleto } from '@/views/14/RegrasDeNegocio14'
import { acionaFuncionalidade as acionaDeclaracao } from '@/views/20/RegrasDeNegocio20'
import { acionaFuncionalidade as acionaExtratoUtilizacao } from '@/views/55/RegrasDeNegocio55'
import { acionaFuncionalidade as acionaCoparticipacao } from '@/views/11/RegrasDeNegocio11'
import { acionaFuncionalidade as acionaPINSS } from '@/views/52/RegrasDeNegocio52'
import { acionaFuncionalidade as acionaExtratoReembolso } from '@/views/10/RegrasDeNegocio10'
import { acionaFuncionalidade as acionaExtratoAutorizacao } from '@/views/31/RegrasDeNegocio31'
import { acionaFuncionalidade as acionaFuncionalidadePadrao } from '@/components/TemplateSolicitacao/componentes/RegrasDeNegocio'

const configuraRequestFuncionalidade = {
  4: acionaRedeCredenciada,
  14: acionaBoleto,
  20: acionaDeclaracao,
  55: acionaExtratoUtilizacao,
  11: acionaCoparticipacao,
  52: acionaPINSS,
  10: acionaExtratoReembolso,
  31: acionaExtratoAutorizacao,
  51: acionaFuncionalidadePadrao,
  16: acionaFuncionalidadePadrao,
  50: acionaFuncionalidadePadrao
}

export default configuraRequestFuncionalidade
